const COUNTRY_LABEL_OVERRIDES: Record<string, string> = {
    Danmark: 'Denmark'
};

export const formatCountryLabel = (name: string): string => {
    return COUNTRY_LABEL_OVERRIDES[name] ?? name;
};
